import { GetProposalQuery, UpdateProposalGroupInput } from '@/gql/graphql';
import { produce } from 'immer';

/**
 * Applies the title only. A `selectionMode` change is left to the on-success
 * invalidation, since the server reshapes children's selection state alongside it.
 */
export const applyProposalGroupUpdate = (
  data: GetProposalQuery,
  input: UpdateProposalGroupInput
): GetProposalQuery =>
  produce(data, (draft) => {
    if (input.title === undefined) return;
    for (const section of draft.proposal.sections) {
      if (section.__typename !== 'ProposalItemGroupSection') continue;
      for (const group of section.groups) {
        if (group.key === input.groupKey) {
          group.title = input.title;
          return;
        }
        for (const child of group.children) {
          if (
            child.__typename === 'ProposalItemGroup' &&
            child.key === input.groupKey
          ) {
            child.title = input.title;
            return;
          }
        }
      }
    }
  });
